import type { Variant, Variants } from "motion/react";
import { deepMerge } from "@/lib/utils/object";

export const baseVariants: Record<string, Variants> = {
  fadeInTop: {
    initial: { y: "-100%", opacity: 0 },
    animate: { y: 0, opacity: 1, transition: { duration: 0.4 } },
    exit: { y: "-100%", opacity: 0 },
  },
  fadeInBotton: {
    initial: { y: 50, opacity: 0 },
    animate: { y: 0, opacity: 1, transition: { duration: 0.4 } },
    exit: { y: 50, opacity: 0 },
  },
  fadeIn: {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 0.4 } },
    exit: { opacity: 0 },
  },
  slideRight: {
    initial: { x: -20, opacity: 0 },
    animate: { x: 0, opacity: 1, transition: { duration: 0.4 } },
    exit: { x: 20, opacity: 0 },
  },
  "page-reveal": {
    initial: { y: "0%" },
    animate: {
      y: "-100%",
      transition: { duration: 0.7, ease: [0.87, 0, 0.13, 1] },
    },
    exit: { y: "-100%" },
  },
};

export function getVariant(key: string | Variant): Variants {
  const parts = key.toString().split(" ");

  return parts.reduce(
    (acc, part) => {
      const variant = baseVariants[part];

      if (!variant) {
        return acc;
      }

      return {
        initial: deepMerge(acc.initial ?? {}, variant.initial ?? {}),
        animate: deepMerge(acc.animate ?? {}, variant.animate ?? {}),
        exit: deepMerge(acc.exit ?? {}, variant.exit ?? {}),
      };
    },
    { initial: {}, animate: {}, exit: {} },
  );
}
